import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

type Props = {
  id: string;
  errorText: string;
};

const Error = ({ id, errorText }: Props) => (
  <div className="text-base flex items-center" data-testid="error">
    <div className="w-6 mr-1">
      <ExclamationCircleIcon color="rgb(153, 27, 27)" />
    </div>
    <span className="text-red-800" id={id}>
      {errorText}
    </span>
  </div>
);

export default Error;
